import * as React from 'react';

import { LinkText } from 'common/components';
import { Glossary, PlanListGL } from 'common/utils/glossary';

interface Props {
  /** LinxTextを表示するか否か */
  show: boolean;
  /** 「< 全ての商品を表示する」クリック時の処理 */
  onClickAllPlan: () => void;
  /** グロッサリ */
  glossary: Glossary;
}

/**
 * 全ての商品を表示用LinkTextのPresentation Component
 */
export const AllPlanDispLink: React.FC<Props> = ({
  show,
  onClickAllPlan,
  glossary
}) => {
  return show ? (
    <LinkText
      type="allPlanLink"
      data-test={`allPlanLink`}
      onClick={onClickAllPlan}
    >
      &lt; {glossary.glx(PlanListGL.ReturnToTop)}
    </LinkText>
  ) : null;
};
